import { Flex } from "@similarweb/ui-components/foundations";

import { IntentDistributionChart } from "app/pages/keyword-research/common-components/intent-distribution-chart/IntentDistributionChart";
import type { IIntentDistributionChartData } from "app/pages/keyword-research/common-components/intent-distribution-chart/intentDistributionChartTypes";

export const KeywordGroupIntent = ({ data, isLoading }: { data: IIntentDistributionChartData; isLoading: boolean }) => {
    return (
        <Flex
            flexDirection="column"
            padding="16px 32px 24px"
        >
            <IntentDistributionChart
                data={data}
                isLoading={isLoading}
                noDataContainerWidth="100%"
            />
        </Flex>
    );
};
